import React, { PureComponent } from "react";
import SideMenu from 'components/SideMenu';
import Announcements from 'pages/information/announcements'
import HotNews from 'pages/information/hotNews'
import Other from 'pages/information/other'
import SoldierConsulting from 'pages/information/soldierConsulting'
import { Switch, Route, Redirect } from "react-router-dom";
require("./index.css");


export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      navNum: '',
      active: 0,
      dataList: [
        {
          txt: "通知公告",
          type: 1,
          component: Announcements,
          path: '/entrance/information/announcements'
        },
        {
          txt: "热点新闻",
          type: 2,
          component: HotNews,
          path: '/entrance/information/hotNews'
        },
        {
          txt: "军人资讯",
          type: 3,
          component: SoldierConsulting,
          path: '/entrance/information/soldierConsulting'
        },
        {
          txt: "其他",
          type: 4,
          component: Other,
          path: '/entrance/information/other'
        },
      ],
      data: []
    };
  }


  componentDidMount() {

  }


  render() {
    return (
      <div>
        {/* 内容 */}
        <div className="content">
          <div className="container clear">
            <SideMenu title={'动态资讯'} data={this.state.dataList} />

            {
              this.state.dataList.map((item, index) => {

                return (
                  <Route path={item.path} component={item.component} key={index} />
                )

              })
            }
            {/* <Redirect from="/entrance/information" to="/entrance/information/announcements" /> */}
          </div>
        </div>
        {/* 内容 */}
      </div>
    );
  }
}
